import { get, post, patch } from "./apiService";

export const fetchAccounts = async () => {
  return get({ path: 'Account' });
}

export const fetchAccountById = async (id) => {
  return get({ path: `Account/filtered` });
}

export const addAccount = async (payload, keepAlive = false) => {
  return post({ path: 'Account', body: payload, keepAlive: keepAlive });
}

export const updateAccount = async (payload, keepAlive = false) => {
  return patch({ path: `Account/update`, body: payload, keepAlive: keepAlive });
}